import React from 'react';
import PropTypes from 'prop-types';

import ButtonSubmitDeprecated from "src/core/gd-form/common/btn-submit/btn-submit-ui5";

export default function CustomFieldActions(props) {
    return (
        <div className="bottom-action">
            <ButtonSubmitDeprecated form={props.form} className="submit" label="Save"/>
        </div>
    );
}

CustomFieldActions.propTypes = {
    form: PropTypes.object
}